export default "__VITE_ASSET__D$ir6Es___"